<template>
  <section class="session">
    <div class="body__content">
      <div class="session__content">
        <h2>Producer and Case Information</h2>

        <form class="session__fields" @submit.prevent="trySetNewSession">
          <unum-textbox
            name="producerName"
            label="Producer Name"
            placeholder="Producer Name Example"
            v-model="newSession.producerName"
            v-validate="'required'"
            data-vv-value-path="producerName"
            data-vv-validate-on="blur"
            :errorBag="errors"
          />

          <unum-textbox
            name="caseName"
            label="Case Name"
            placeholder="Case Name Example"
            v-model="newSession.caseName"
            v-validate="'required'"
            data-vv-value-path="caseName"
            data-vv-validate-on="blur"
            :errorBag="errors"
          />

          <unum-textbox
            name="producerNumber"
            label="Producer Number"
            placeholder="Producer Number Example"
            v-model="newSession.producerNumber"
            v-validate="'required|numeric'"
            data-vv-value-path="producerNumber"
            data-vv-validate-on="blur"
            :errorBag="errors"
          />

          <div
            :class="[
              'unum-field',
              'unum-field--select',
              {'has-errors': errors.has('caseState')}
            ]"
          >
            <label for="caseState">Case State</label>
            <!-- <v-select
              label="caseState"
              name="caseState"
              placeholder="Choose a State"
              inputId="caseState"
              v-model="newSession.caseState"
              :maxHeight="'150px'"
              :options="stateData"
              v-validate="'required'"
              data-vv-value-path="caseState"
              data-vv-validate-on="blur"
              :class="{'has-errors': errors.has('caseState')}"
            >
            </v-select> -->

            <div class="selectWrapper">
              <select
                name="caseState"
                id="caseState"
                v-model="newSession.caseState"
                v-validate.disable="'required'"
                data-vv-value-path="caseState"
                data-vv-validate-on="blur"
                :class="{
                  'has-errors': errors.has('caseState'),
                  'has-not-selected': !!!newSession.caseState
                }"
              >
                <option disabled :value="null">Choose State</option>
                <option
                  v-for="state in stateData"
                  :value="state"
                  :key="state"
                >
                  {{state}}
                </option>
              </select>
            </div>
            <span
              v-if="errors && errors.has('caseState')"
              class="unum-field__help error"
            >
              {{ errors.first('caseState') }}
            </span>
          </div>

          <unum-textbox
            name="brokerName"
            label="Broker Name"
            help-text="Enter 'direct' if not using a broker."
            placeholder="Broker Name Example"
            v-model="newSession.brokerName"
            v-validate="'required'"
            data-vv-value-path="brokerName"
            data-vv-validate-on="blur"
            :errorBag="errors"
          />

          <unum-textbox
            name="caseSize"
            label="Case Size"
            placeholder="Case Size Example"
            v-model="newSession.caseSize"
            v-validate="'required|numeric'"
            data-vv-value-path="caseSizde"
            data-vv-validate-on="blur"
            :errorBag="errors"
          />

          <unum-button>Submit</unum-button>
          <!-- <unum-button @click.native.prevent="cheat">Cheat</unum-button> -->
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'

import UnumButton from '@/components/ui/Button'
import UnumTextbox from '@/components/ui/Textbox'
import { store } from '@/store'
import unitedStatesData from '@/assets/states.js'
import sessionEvent from '@/util/sessionEvent'

Vue.use(vSelect)

export default {
  name: 'UnumSession',
  components: {
    UnumButton,
    UnumTextbox,
    vSelect
  },
  data () {
    return {
      stateData: unitedStatesData.map(state => state),
      newSession: {
        agentEmail: null,
        producerName: null,
        producerNumber: null,
        brokerName: null,
        caseName: null,
        caseState: null,
        caseSize: null
      }
    }
  },
  async mounted () {
    if (this.user) {
      this.newSession.agentEmail = await this.user.email
    }

    if (this.session) {
      this.newSession = {
        ...this.session
      }

      this.$modal.show('dialog', {
        title: 'Caution',
        text: `
          Do you want to start over with your <strong>current case</strong> information or
          <strong>new case</strong> information?
        `,
        buttons: [
          {
            title: 'Edit Case',
            handler: () => {
              const sessionKey = this.$storage.get('session_key')
              sessionEvent(sessionKey, 'clicked_modal_edit_case_button')
              this.clearWizard()
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'New Case',
            handler: () => {
              const sessionKey = this.$storage.get('session_key')
              sessionEvent(sessionKey, 'clicked_modal_new_case_button')
              this.newSession = {
                agentEmail: null,
                producerName: null,
                producerNumber: null,
                brokerName: null,
                caseName: null,
                caseState: null,
                caseSize: null
              }
              this.clearSession()
              this.clearWizard()
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    }
  },
  computed: {
    ...mapState('user', [
      'session',
      'user'
    ]),
    ...mapGetters('user', [
      'isSessionSet'
    ])
  },
  methods: {
    ...mapActions('user', [
      'setNewSession',
      'clearSession'
    ]),
    ...mapActions('wizard', [
      'clearWizard'
    ]),
    trySetNewSession () {
      this.$validator.validate().then((result) => {
        // eslint-disable-next-line
        console.log(`Validation Result: ${result}`);
        if (result) {
          this.setNewSession(this.newSession)
            .then(async (res) => {
              this.$router.push({ name: 'Home' })
              const sessionKey = this.$storage.get('session_key')
              sessionEvent(sessionKey, 'submit_initial_form', this.newSession)
            })
        }
      })
    },
    cheat () {
      this.newSession.producerName = 'Agent Smith'
      this.newSession.producerNumber = '000001'
      this.newSession.brokerName = 'Neo'
      this.newSession.caseName = 'Matrix'
      this.newSession.caseState = 'South Carolina'
      this.newSession.caseSize = '501'
    }
  },
  beforeRouteLeave: (to, from, next) => {
    console.warn('beforeRouteLeave()')
    if (to.name !== 'Login') {
      if (store.getters['user/isSessionSet'] || store.getters['user/user'] !== null) {
        next()
      }
    } else {
      next()
    }
  }
}

</script>

<style lang="scss">
.session {
  background: $lightBlue;
  height: calc(100% - 8rem);
  padding: 2rem 2rem 0;
  overflow: auto;

  @include bp($medium) {
    height: calc(100% - 5rem);
    padding: 0;
  }

  &__content {
    max-width: 612px;
    // margin: 0 auto;
    margin: 2rem auto;
    padding: 0 0 2rem 0;
  }

  &__fields {
    @include bp($small) {
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
      height: 22rem;
      align-content: space-between;
    }

    .unum-field {
      @include bp($small) {
        width: calc(50% - 2rem);
        flex: 0 0 auto;
      }
    }
  }
}

.v-select {
  width: 100%;

  & + .unum-field__help {
    margin-top: .25rem;
  }
}

.unum-field {
  // `/deep/` makes this scoped style available to child components
    // in this case, overriding the 3rd party child component `v-select`
  // & /deep/ .v-select {

  .selectWrapper {
    position: relative;
    background: #fff;
    margin: 0 auto .25rem;
    &:before {
      content: "";
      border-color: rgba(60,60,60,.5);
      border-style: solid;
      border-width: 3px 3px 0 0;
      height: 10px;
      vertical-align: top;
      transform: rotate(133deg);
      box-sizing: inherit;
      display: inline-block;
      transition: all .15s cubic-bezier(1,-.115,.975,.855);
      transition-timing-function: cubic-bezier(1,-.115,.975,.855);
      width: 10px;
      position: absolute;
      bottom: 1.5rem;
      right: 1rem;
    }
  }

  & select {
    cursor: pointer;
    padding: 1rem;
    border-radius: 3px;
    border: 0;
    margin: 0 auto;
    width: 100%;
    border: .063rem solid #ADC5D5;
    position: relative;
    z-index: 1;
    background: transparent;
    -webkit-appearance: none; /* Webkit */
    -moz-appearance: none; /* FF */
    -ms-appearance: none; /* Edge */
    appearance: none;
    &::-ms-expand {
      display: none;
    }

    &.has-not-selected {
      color: $grey;
    }

    &:focus {
      outline: 0;
      border-color: darken(#ADC5D5, 25%);
    }

    .has-errors & {
      border: .063rem solid red;
      color: $red;
    }
  }

  & select,
  & .v-select {
    border: .063rem solid #ADC5D5;
    border-radius: 3px;

    &.has-errors {
      border-color: $red;

      .selected-tag {
        color: $red;
      }
      .dropdown-toggle {
        background: #FFEFE1;
      }
    }

    &.open {
      .open-indicator {
        transform: rotate(180deg);
      }
    }

    input[type="search"],
    input[type="search"]:focus {
      margin: .55rem;
      width: calc(100% - 3rem);
      height: 2rem;
      // padding-left: 1.25rem;
      // padding-right: 1.25rem;
    }
    .open-indicator {
      bottom: auto;
      top: 1.115rem;
      height: 1rem;
      &:before {
        transform: rotate(135deg);
        // border-width: .063rem .063rem 0 0;
      }
    }
    .dropdown-toggle {
      border-radius: 3px;
      // background: #eff1ed;
      background: #fff;
      border: 0;

      .clear {
        bottom: auto;
        top: .75rem;
      }
    }
    .dropdown-menu {
      // background: #eff1ed;
      background: #fff;
      border: 0;
      li.no-options {
        margin: 0 .5rem;
      }
    }
    .selected-tag {
      position: absolute;
      left: 0;
      padding: .5rem 1rem;
      width: 100%;
      height: 100%;
      // margin: .250rem .063rem 0 .188rem;
      border: 0;
      margin: 0;
      line-height: 2;
    }
  }
}

// /* Cyan theme */
// .v-select .selected-tag {
//     color: #147688;
//     background-color: #d7f3f9;
//     border-color: #91ddec;
// }

// .v-select.dropdown.open .dropdown-toggle,
// .v-select.dropdown.open .dropdown-menu {
//     border-color: #4CC3D9;
// }

// .v-select .active a {
//     background: rgba(50,50,50,.1);
//     color: #333;
// }

// .v-select.dropdown .highlight a,
// .v-select.dropdown li:hover a {
//     background: #4CC3D9;
//     color: #fff;
// }
</style>



// WEBPACK FOOTER //
// src/components/Session.vue